import { TranslateDirective, TranslationService } from '@foundation/translations/services';

import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';

interface AdditionalAdminNavigationItem {
	label: () => string;
	path: string;
}

@Component({
	selector: 'lib-admin-shell',
	standalone: true,
	imports: [RouterModule, TranslateDirective],
	templateUrl: './admin-shell.component.html',
	styleUrl: './admin-shell.component.css',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminShellComponent {
	private _activatedRoute = inject(ActivatedRoute);
	private _translationService = inject(TranslationService);

	additionalNavigationItems: AdditionalAdminNavigationItem[] =
		this._activatedRoute.routeConfig?.children
			?.filter((route) => typeof route.data?.['adminNavigationLabel'] === 'string' && typeof route.path === 'string')
			.map((route) => ({
				label: this._translationService.prep(route.data?.['adminNavigationLabel']),
				path: `/admin/${route.path}`,
			})) ?? [];
}
